import React from 'react';
import PropTypes from 'prop-types';
import AuthContext from 'contexts/JWTContext';
import { isAuthorizedForRoles } from 'utils/permission';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'store';
import useAuth from 'hooks/useAuth';

const getPermissionItems = ({ action, resource, permissions }) => {
    if (Array.isArray(permissions)) {
        return permissions;
    }

    if (permissions?.action || permissions?.resource) {
        return [permissions];
    }

    return [{ action, resource }];
};

const PermissionDisplay = ({
    children,
    action,
    resource,
    route = null,
    permissions = null,
    allowTrial = true,
    excludeSupportAdmin = false
}) => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const context = React.useContext(AuthContext);
    const { clientSettings } = useSelector((state) => state.settings);
    const { trial = false } = clientSettings;
    const location = useLocation();

    const userRoles = context?.user?.roles || [];
    const permissionItems = getPermissionItems({ action, resource, permissions });
    let isAuthorized = permissionItems.some((item) =>
        isAuthorizedForRoles(userRoles, item?.action || action, item?.resource || resource, item?.isAdminNotAuthorized)
    );

    React.useEffect(() => {
        if (!(trial && allowTrial) && !isAuthorized && route === location.pathname && route !== null) {
            navigate('/', { replace: true });
        }
    }, [allowTrial, isAuthorized, location.pathname, navigate, route, trial]);

    /**
     * If excludeSupportAdmin is set to true
     * check if current user is support admin
     */
    if (excludeSupportAdmin && user?.isAccessAdmin) {
        isAuthorized = false;
    }

    // still show the nav items even if trial
    return isAuthorized || (trial && allowTrial) ? <>{children}</> : null;
};

PermissionDisplay.propTypes = {
    allowTrial: PropTypes.bool,
    children: PropTypes.any,
    action: PropTypes.any,
    resource: PropTypes.any,
    permissions: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)]),
    route: PropTypes.any
};

export default PermissionDisplay;
